<template>
  <div class="headerContainer">
    <div class="container">
        <img class="animate__animated animate__fadeInLeft"  src="@/assets/images/logoHeader.png" alt="" srcset="" style="width:220px;display:block;float:left;margin:30px 0 0 0" @click="goHome">
       
       <span style="display:block;float:right;color:#272a36;cursor:pointer" @click="goEN">
          <!-- <b v-if="isEN"> 中 ｜ <span style="color:red">EN</span></b>
          <b v-else> <span style="color:#d32c37">中 </span>| EN</b> -->
          <b > <span style="color:#d32c37">中 </span>| EN</b>
        </span>
        <img src="@/assets/images/search.png" alt="" srcset="" style="width:30px;display:block;float:right;margin:45px 50px 0 0;cursor:pointer" @click="search">
        <div class="menu" style="float:right;margin:0 150px 0 0;">
            <ul class="menu">  
                <li v-for="(item, index) in menuItems" :key="index" :class="index === curIndex?'selected':''">  
                  <a :href="item.path==='/'?'/#/':`${item.path}?id=${item.id}&type=${item.model_type}`"  @click="handleIndex(index,item)">{{ item.name }}</a>  
                </li>  
            </ul> 
        </div>
    </div>
    <div class="clearBoth"></div>
  </div>
</template>
<script>
import { cate } from '@/api/index.js'
export default {
  name: 'App',
  data() {  
    return {  
     isEN:false,
     curIndex:0,
     selected: false,
      menuItems: [  
        // { text: '首页',link: '/' },  
        // { text: '解决方案',link: '/#/solution' },  
        // { text: '新闻资讯',link: '/#/news' },  
        // { text: '设备管理',link: '/#/equipment' },
        // { text: '关于我们',link: '/#/aboutUs' },  
        // { text: '视频中心',link: '/#/video' },  
        // { text: '联系我们',link: '/#/contactUs' },  
        // 添加更多菜单项...  
      ],  
    };  
  }, 
  mounted() {  
    this.isLang()
    this.cateEvent()
    if(this.getSubstring()) {
      let _sub = this.getSubstring()
      let _arr = ['','solution','news','equipment','aboutUs','video','contactUs']
      this.curIndex = _arr.indexOf(_sub)
    } else {
      this.curIndex = 0
    }

  },
  methods:{
    goEN() {
      window.location.href = 'https://en.youlimei.com/#/'
    },
    isLang(){
      if(localStorage.getItem('YLMlang') === 'en') {
        this.isEN = true
      } else {
        this.isEN = false
      }
    },
    changelang() {
      let _lang = localStorage.getItem('YLMlang')
      if(_lang && _lang === 'en') {
        localStorage.setItem('YLMlang','cn')
      } else {
        localStorage.setItem('YLMlang','en')
      }
      this.goHome()
      window.location.reload()
    },
    getSubstring() {
      const url = window.location.href; // 获取当前页面的URL
      const hashIndex = url.indexOf('#/'); // 找到#/的位置
      const questionMarkIndex = url.indexOf('?', hashIndex); // 从#/的位置开始，找到?的位置

      if (hashIndex !== -1 && questionMarkIndex !== -1) {
        // 如果#/和?都存在，截取它们之间的字符串
        return url.substring(hashIndex + 2, questionMarkIndex);
      } else if (hashIndex !== -1) {
        // 如果只有#/存在，截取#/之后的所有字符串
        return url.substring(hashIndex + 2);
      }
      return ''; // 如果没有找到#/或?，返回空字符串
    },
    cateEvent() {
        this.$nextTick(()=>{
            cate().then((res)=>{
                this.menuItems = res.data
            })
        })
    },
    goHome() {
      this.curIndex = 0
      this.$router.push({ path: '/' })
    },
    search() {
      this.curIndex = -1
      this.$router.push({ path: '/search' })
    },
    // 重新加载方法
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(()=>{
        this.isRouterAlive = true;
      })
    },
    handleIndex(index,item){
      this.curIndex = index
      // this.$router.push({ path: `${item.path}` })

      // this.$router.push({ path: '/search' })
    }
  }
}
</script>
<style lang="scss" scoped>
.headerContainer{
    background: #f7f7f7;
}
.container{
    width:1300px;
    margin: 0 auto;
    height: 110px;
    line-height: 110px;
}
.menu {  
  list-style: none;  
  padding: 0;  
}  
  
.menu li {  
  display: inline-block;  
  //   margin-right: 10px;  
  width:100px;
  text-align: center;
  font-size: 14px;
}  
.menu li.selected {
   
    padding: 3px 0;
    display: inline-block;
    line-height: 34px;
}
.menu li a {  
  text-decoration: none;  
  padding: 0px 0px 10px 0px; 
  color: #272a36;  
} 
.menu li.selected a {
 color: #272a36;  
 border-bottom: 3px solid #d32c37;
}
// li.selected a {  
//   background-color: #4caf50;  
//   color: white;  
//   text-decoration: underline;
// }  
  
.fade-enter-active, .fade-leave-active {  
  transition: opacity 0.5s;  
}  
  
.fade-enter, .fade-leave-to {  
  opacity: 0;  
} 
.clearBoth {
    clear: both;
	height: 0px;
	line-height: 0px;
	font-size: 0px;
}
</style>
